import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-multipoint-modal-have-installations',
  templateUrl: './multipoint-modal-have-installations.component.html',
  styleUrls: ['./multipoint-modal-have-installations.component.scss']
})
export class MultipointModalHaveInstallationsComponent {

  constructor(private dialogRef: MatDialogRef<MultipointModalHaveInstallationsComponent>) { }

  public closeModal(overwrite: boolean): void {
    this.dialogRef.close(overwrite);
  }

}
